import Footer from './separate/Footer'
import { Box, Button, Card, CardContent, Typography } from '@mui/material'
import {
  BookOpen,
  TrendingUp,
  Target,
  Shield,
  BarChart3,
  Zap,
  Play,
  Calendar,
  Users,
  Award,
  ExternalLink,
  Youtube,
  ArrowRight,
  Coins,
  Rocket,
} from 'lucide-react'
import NavbarOne from './separate/NavbarOne'
import './Earn.css'
import { useNavigate } from 'react-router-dom'
import CustomChip from '../Component/CustomChip/CustomChip'
import Title from '../Component/Title/Title'
import SubTitle from '../Component/SubTitle/SubTitle'
import { useTheme, useMediaQuery } from '@mui/material';
import PageTitleDes from '../core/support/PageTitleDes'

const workshopTopics = [
  {
    icon: BookOpen,
    title: 'Blockchain Basics',
    description:
      'Understand the fundamentals of blockchain technology, decentralization, and how cryptocurrencies work.',
  },
  {
    icon: BarChart3,
    title: 'Crypto Analysis',
    description:
      'Learn how to research and evaluate cryptocurrency projects before making investment decisions.',
  },
  {
    icon: TrendingUp,
    title: 'Technical Analysis',
    description:
      'Master chart patterns, indicators, and price action to predict market movements.',
  },
  {
    icon: Target,
    title: 'Fundamental Analysis',
    description:
      'Evaluate crypto projects based on technology, team, tokenomics, and market potential.',
  },
  {
    icon: Shield,
    title: 'Risk Management',
    description:
      'Learn stop loss strategies, position sizing, and how to protect your capital.',
  },
  {
    icon: Zap,
    title: 'Entry & Exit Points',
    description:
      'Identify optimal times to enter and exit trades for maximum profitability.',
  },
]

const tradingModules = [
  {
    id: 'spot',
    title: 'Spot Trading',
    subtitle: 'Buy & Sell Instantly',
    description:
      'Buy and sell cryptocurrencies at current market prices with instant settlement. Perfect for beginners and long-term investors.',
    features: [
      'Market Orders',
      'Limit Orders',
      'Order Book Analysis',
      'Trading Pairs',
    ],
    icon: Coins,
    color: 'from-primary/20 to-primary/5',
    borderColor: 'border-primary/30',
    stats: { risk: 'Low', leverage: '1x', settlement: 'Instant' },
  },
  {
    id: 'futures',
    title: 'Futures Trading',
    subtitle: 'Amplify Your Gains',
    description:
      'Trade cryptocurrency derivatives with leverage for amplified gains. For experienced traders seeking higher returns.',
    features: [
      'Leverage Trading',
      'Long & Short Positions',
      'Margin Management',
      'Liquidation Prevention',
    ],
    icon: Rocket,
    color: 'from-accent/20 to-accent/5',
    borderColor: 'border-accent/30',
    stats: { risk: 'High', leverage: 'Up to 125x', settlement: 'Contract' },
  },
]
const Learn = (props) => {
  const navigate = useNavigate()
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <div
      style={{ minHeight: '100vh', backgroundColor: '#0B0E14', color: '#fff' }}
    >
      <PageTitleDes title={`Crypto Learning Platform | Unitic Academy for Beginners & Traders`} description={`Learn cryptocurrency trading from experts at Unitic Academy. Beginner to advanced courses, strategies, and market insights all in one place.`} />
      <NavbarOne setTheme={props.setTheme} />

      <section
        style={{
          position: 'relative',
          paddingTop: '8rem',
          // paddingBottom: '5rem',
          overflow: 'hidden',
          background:
            'radial-gradient(600px circle at 12% 15%, rgba(29,160,148,0.14), transparent 60%), radial-gradient(520px circle at 88% 28%, rgba(29,160,148,0.10), transparent 60%), linear-gradient(180deg, rgba(8,12,16,0.95) 0%, #0B0E14 100%)',
        }}
      >
        <div className='container position-relative'>
          <div
            className='text-center'
            style={{ maxWidth: '64rem', margin: '0 auto' }}
          >
            <CustomChip>
              <BookOpen size={16} color='#1da094' />
              Education Hub
            </CustomChip>

            <h1
              className='headTitle'
              style={{
                fontWeight: 800,
                marginBottom: '1rem',
              }}
            >
              Master Crypto Trading with{' '}
              <span
                style={{
                  background:
                    'linear-gradient(90deg, #1da094 0%, #34d399 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                Expert Guidance
              </span>
            </h1>

            <p
              className='subHeadTitle'
              style={{
                color: '#a3a3a3',
                maxWidth: '40rem',
                margin: '0 auto 2rem',
              }}
            >
              Join our one-day workshops and learn everything from blockchain
              basics to advanced trading strategies. Plus, access free
              educational content on our YouTube channel.
            </p>
            <br />
            <div className='d-flex flex-column flex-sm-row align-items-center justify-content-center gap-3'>
              <Button
                variant='contained'
                size='large'
                style={{ backgroundColor: '#1da094', color: 'white' }}
                onClick={() => navigate('/help-center')}
              >
                <Calendar size={18} style={{ marginRight: 8 }} />
                Register for Workshop
              </Button>
              <Button
                variant='outlined'
                size='large'
                component='a'
                href='https://www.youtube.com/@UniticExchange2025'
                target='_blank'
                rel='noopener noreferrer'
                style={{ borderColor: '#1da094', color: '#1da094' }}
                className='learnYoutubeBtn'
              >
                <Youtube size={18} style={{ marginRight: 8 }} />
                Watch on YouTube
              </Button>
            </div>
          </div>

          <div
            className='row row-cols-2 row-cols-sm-4 g-3'
            style={{ maxWidth: '48rem', margin: '4rem auto 0' }}
          >
            {[
              { value: '50+', label: 'Workshops Conducted' },
              { value: '500+', label: 'Trained' },
              { value: '100+', label: 'Video Tutorials' },
              { value: '4.9', label: 'Average Rating' },
            ].map((stat) => (
              <div key={stat.label} className='col text-center'>
                <div
                  style={{
                    fontSize: '1.75rem',
                    fontWeight: 700,
                    color: '#fff',
                  }}
                >
                  {stat.value}
                </div>
                <div
                  style={{
                    fontSize: '0.875rem',
                    color: '#a3a3a3',
                    marginTop: 4,
                  }}
                >
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ paddingTop: '7rem', backgroundColor: '#0B0E14' }}>
        <div className='container'>
          <div className='text-center mb-4'>
            <Title variant='h2'>
              What You'll Learn in Our{' '}
              <span style={{ color: '#1da094' }}>Workshops</span>
            </Title>
            <SubTitle>Our comprehensive one-day workshops cover everything you need to
              start trading confidently.</SubTitle>
          </div>

          <div
            className='row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-3'
            style={{ maxWidth: '76rem', margin: '50px auto' }}
          >
            {workshopTopics.map((topic) => (
              <div key={topic.title} className='col'>
                <Card
                  sx={{
                    backgroundColor: '#0f1216',
                    border: '1px solid rgba(255,255,255,0.05)',
                    borderRadius: '12px',
                    height: '100%',
                    transition: 'all 0.3s ease',
                    textAlign: 'left',
                    '&:hover': {
                      border: '1px solid #1da094',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 4px 20px rgba(29, 160, 148, 0.1)',
                    },
                  }}
                >
                  <CardContent sx={{ padding: '32px' }}>
                    <div
                      className='d-flex align-items-center justify-content-center mb-4'
                      style={{
                        width: 48,
                        height: 48,
                        borderRadius: 12,
                        background: 'rgba(29,160,148,0.1)',
                        border: '1px solid rgba(29,160,148,0.2)',
                      }}
                    >
                      <topic.icon size={24} color='#1da094' />
                    </div>
                    <h3
                      style={{
                        fontSize: '1.25rem',
                        fontWeight: 700,
                        marginBottom: 12,
                        color: '#fff',
                      }}
                    >
                      {topic.title}
                    </h3>
                    <p
                      style={{
                        color: '#9ca3af',
                        fontSize: '0.95rem',
                        lineHeight: 1.6,
                        margin: 0,
                      }}
                    >
                      {topic.description}
                    </p>
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        style={{ padding: '5rem 0', position: 'relative', overflow: 'hidden' }}
      >
        <div className='container position-relative'>
          <div className='text-center mb-5'>
            <CustomChip>
              <BarChart3 size={16} color='#1da094' />
              <span style={{ fontSize: 14, color: '#a3a3a3' }}>
                Master Both Methods
              </span>
            </CustomChip>
            <Title variant='h2'>
              Trading <span style={{ color: '#1da094' }}>Modules</span>
            </Title>
            <SubTitle>Deep dive into different trading methods with hands-on practice
              sessions.</SubTitle>
          </div>

          <div style={{ maxWidth: '76rem', margin: '80px auto' }}>
            <div className='row g-4'>
              {tradingModules.map((module) => (
                <div key={module.id} className='col-12 col-lg-6'>
                  <Box
                    sx={{
                      borderRadius: '1.5rem',
                      border: '1px solid rgba(29, 160, 148, 0.2)',
                      background: '#0f1216',
                      padding: { xs: '1rem', md: '2.5rem' },
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <div className='d-flex align-items-start justify-content-between mb-2'>
                      <div>
                        <div
                          className='d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3'
                          style={{
                            background: 'rgba(29, 160, 148, 0.1)',
                            border: '1px solid rgba(29, 160, 148, 0.2)',
                          }}
                        >
                          <module.icon size={14} color='#1da094' />
                          <span
                            style={{
                              fontSize: 12,
                              color: '#1da094',
                              fontWeight: 600,
                            }}
                          >
                            {module.subtitle}
                          </span>
                        </div>
                        <h3
                          className='tradeModTitle'
                          style={{
                            fontWeight: 800,
                            color: '#fff',
                            marginBottom: '1rem',
                          }}
                        >
                          {module.title}
                        </h3>
                      </div>
                      <div
                        className='d-flex align-items-center justify-content-center'
                        style={{
                          width: 64,
                          height: 64,
                          borderRadius: 20,
                          background: 'rgba(29, 160, 148, 0.1)',
                          border: '1px solid rgba(29, 160, 148, 0.2)',
                        }}
                      >
                        <module.icon size={32} color='#1da094' />
                      </div>
                    </div>

                    <p
                      className='tradeModSubTitle'
                      style={{
                        color: '#9ca3af',
                        marginBottom: '2rem',
                        lineHeight: 1.6,
                      }}
                    >
                      {module.description}
                    </p>
                    <br />
                    <div
                      className='glass-card row row-cols-3 g-0 mb-4'
                      style={{
                        padding: '1rem 0',
                      }}
                    >
                      {Object.entries(module.stats).map(
                        ([key, value], index) => (
                          <div
                            key={key}
                            className='col text-center'
                            style={{
                              borderRight:
                                index < 2
                                  ? '1px solid rgba(255, 255, 255, 0.05)'
                                  : 'none',
                            }}
                          >
                            <div
                              style={{
                                fontSize: 11,
                                textTransform: 'uppercase',
                                letterSpacing: 1,
                                color: '#6b7280',
                                marginBottom: 6,
                                fontWeight: 600,
                              }}
                            >
                              {key}
                            </div>
                            <div
                              style={{
                                fontSize: 15,
                                fontWeight: 700,
                                color: '#fff',
                              }}
                            >
                              {value}
                            </div>
                          </div>
                        ),
                      )}
                    </div>

                    <div className='mb-4 flex-grow-1'>
                      {module.features.map((feature, i) => (
                        <div
                          key={feature}
                          className='d-flex align-items-center gap-3 mb-2'
                          style={{
                            padding: '12px 16px',
                            borderRadius: 12,
                            background: 'rgba(255, 255, 255, 0.02)',
                          }}
                        >
                          <div
                            className='d-flex align-items-center justify-content-center'
                            style={{
                              width: 24,
                              height: 24,
                              borderRadius: '50%',
                              background: 'rgba(29, 160, 148, 0.15)',
                              flexShrink: 0,
                            }}
                          >
                            <span
                              style={{
                                fontSize: 12,
                                fontWeight: 700,
                                color: '#1da094',
                              }}
                            >
                              {i + 1}
                            </span>
                          </div>
                          <span
                            style={{
                              fontSize: 15,
                              color: '#e5e7eb',
                              fontWeight: 500,
                            }}
                          >
                            {feature}
                          </span>
                        </div>
                      ))}
                    </div>

                    <Button
                      onClick={() => navigate('/comingsoon')}
                      fullWidth
                      style={{
                        background: 'rgba(255, 255, 255, 0.03)',
                        border: '1px solid rgba(255, 255, 255, 0.05)',
                        color: '#fff',
                        padding: '16px',
                        borderRadius: 12,
                        textTransform: 'none',
                        justifyContent: 'space-between',
                        fontSize: '1rem',
                        fontWeight: 600,
                      }}
                    >
                      <span>Learn {module.title}</span>
                      <ArrowRight size={18} />
                    </Button>
                  </Box>
                </div>
              ))}
            </div>

            <div className='d-flex align-items-center justify-content-center mt-5'>
              <div
                className='d-flex align-items-center gap-4 px-4 py-3 rounded-pill border'
                style={{
                  background: 'rgba(255,255,255,0.03)',
                  borderColor: 'rgba(200,200,200,0.2)',
                }}
              >
                <div className='d-flex align-items-center gap-2'>
                  <div
                    style={{
                      width: 12,
                      height: 12,
                      borderRadius: 6,
                      background: '#1da094',
                    }}
                  />
                  <span style={{ fontSize: 14, color: '#a3a3a3' }}>
                    Beginner Friendly
                  </span>
                </div>
                <div
                  style={{
                    width: 1,
                    height: 16,
                    background: 'rgba(200,200,200,0.3)',
                  }}
                />
                <div className='d-flex align-items-center gap-2'>
                  <div
                    style={{
                      width: 12,
                      height: 12,
                      borderRadius: 6,
                      background: '#1da094',
                    }}
                  />
                  <span style={{ fontSize: 14, color: '#a3a3a3' }}>
                    Advanced Traders
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: '0', backgroundColor: '#0B0E14' }}>
        <div className='container'>
          <div style={{ maxWidth: '76rem', margin: '0 auto' }}>
            <div className='row g-4 align-items-center'>
              <div className='col-12 col-lg-6'>
                <div
                  className='d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill border mb-3'
                  style={{
                    background: 'rgba(255,0,0,0.08)',
                    borderColor: 'rgba(255,0,0,0.2)',
                  }}
                >
                  <Youtube size={16} color='#ff4d4d' />
                  <span style={{ fontSize: 14, color: '#ff7a7a' }}>
                    YouTube Channel
                  </span>
                </div>

                <h2
                  style={{
                    fontWeight: 800,
                    marginBottom: '1rem',
                  }}
                >
                  Free Education on{' '}
                  <span style={{ color: '#ff4d4d' }}>YouTube</span>
                </h2>

                <p style={{ color: '#a3a3a3', marginBottom: '1rem' }}>
                  Can't attend a workshop? No problem! We continuously educate
                  the crypto community through our YouTube channel with regular
                  video tutorials, market analysis, and trading strategies.
                </p>
                <br />
                <ul
                  style={{
                    listStyle: 'none',
                    paddingLeft: 0,
                    marginBottom: '1.5rem',
                  }}
                >
                  {[
                    'Weekly market analysis videos',
                    'Step-by-step trading tutorials',
                    'Live trading sessions',
                    'Beginner-friendly content',
                  ].map((item) => (
                    <li
                      key={item}
                      className='d-flex align-items-center gap-3'
                      style={{ marginBottom: 8 }}
                    >
                      <div
                        className='d-flex align-items-center justify-content-center'
                        style={{
                          width: 20,
                          height: 20,
                          borderRadius: 10,
                          background: 'rgba(29,160,148,0.2)',
                        }}
                      >
                        <Play size={12} color='#1da094' />
                      </div>
                      <span style={{ fontSize: 14 }}>{item}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  variant='contained'
                  size={isMobile ? 'medium' : 'large'}
                  component='a'
                  href='https://www.youtube.com/@UniticExchange2025'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ backgroundColor: '#1da094', color: 'white' }}
                >
                  <Youtube size={18} style={{ marginRight: 8 }} />
                  Subscribe to Channel
                  <ExternalLink size={16} style={{ marginLeft: 8 }} />
                </Button>
              </div>

              <div className='col-12 col-lg-6'>
                <div
                  style={{
                    backgroundColor: 'rgba(255,255,255,0.03)',
                    aspectRatio: '16/9',
                    borderRadius: 16,
                    overflow: 'hidden',
                    border: '1px solid rgba(200,200,200,0.2)',
                  }}
                >
                  {/* <iframe style={{ width: '100%', height: '100%' }} src="https://www.youtube-nocookie.com/embed/j0zFv_dr3Tk?si=mDFoqil3Ua8VW9NX" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
                  <iframe
                    style={{ width: '100%', height: '100%' }}
                    src='https://www.youtube.com/embed/j0zFv_dr3Tk?si=plQZLSkJGD8tdDwt'
                    title='YouTube video player'
                    frameborder='0'
                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                    referrerpolicy='strict-origin-when-cross-origin'
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: '5rem 0', backgroundColor: '#0B0E14', marginTop: '5rem', marginBottom: '5rem' }}>
        <div className='container'>
          <div style={{ maxWidth: '64rem', margin: '0 auto' }}>
            <Card
              sx={{
                background: '#0f1216',
                border: '1px solid rgba(255,255,255,0.05)',
                borderRadius: '24px',
                overflow: 'hidden',
                position: 'relative',
              }}
            >
              <CardContent
                sx={{
                  padding: { xs: '2rem', sm: '3rem', md: '4rem' },
                  position: 'relative',
                }}
              >
                <div className='row g-5 align-items-center'>
                  <div className='col-12 col-md-7'>
                    <Typography
                      sx={{
                        fontWeight: 800,
                        fontSize: { xs: '1.8rem', md: '2.5rem' },
                        marginBottom: '1rem',
                        color: '#fff',
                        lineHeight: 1.2,
                      }}
                    >
                      Ready to Start Your{' '}
                      <span style={{ color: '#1da094' }}>Trading Journey?</span>
                    </Typography>
                    <p
                      style={{
                        color: '#9ca3af',
                        marginBottom: '2rem',
                        fontSize: '1.1rem',
                        maxWidth: '90%',
                      }}
                    >
                      Join our next workshop and learn from industry experts.
                      Limited seats available!
                    </p>
                    <br />
                    <Button
                      variant='contained'
                      size={isMobile ? 'small' : 'large'}
                      onClick={() => navigate('/help-center')}
                      sx={{
                        backgroundColor: '#1da094',
                        color: 'white',
                        padding: { xs: '10px 16px', md: '12px 32px' },
                        borderRadius: '12px',
                        fontWeight: 600,
                        textTransform: 'none',
                        fontSize: { xs: '0.875rem', md: '1rem' },
                        '&:hover': { bgcolor: '#189a8d' }
                      }}
                    >
                      <Calendar size={20} style={{ marginRight: 10 }} />
                      Book Workshop Seat
                    </Button>
                  </div>

                  <div className='col-12 col-md-5'>
                    <div className='row g-3'>
                      <div className='col-6'>
                        <div
                          style={{
                            background: 'rgba(255,255,255,0.02)',
                            borderRadius: 16,
                            padding: '1.5rem',
                            border: '1px solid rgba(255,255,255,0.05)',
                            height: '100%',
                          }}
                        >
                          <Users
                            size={28}
                            color='#1da094'
                            style={{ marginBottom: 12 }}
                          />
                          <div
                            style={{
                              fontSize: '1.70rem',
                              fontWeight: 700,
                              color: '#fff',
                              marginBottom: 4,
                            }}
                          >
                            30
                          </div>
                          <div style={{ fontSize: 13, color: '#9ca3af' }}>
                            Seats per batch
                          </div>
                        </div>
                      </div>
                      <div className='col-6'>
                        <div
                          style={{
                            background: 'rgba(255,255,255,0.02)',
                            borderRadius: 16,
                            padding: '1.5rem',
                            border: '1px solid rgba(255,255,255,0.05)',
                            height: '100%',
                          }}
                        >
                          <Award
                            size={28}
                            color='#1da094'
                            style={{ marginBottom: 12 }}
                          />
                          <div
                            style={{
                              fontSize: '1.70rem',
                              fontWeight: 700,
                              color: '#fff',
                              marginBottom: 4,
                            }}
                          >
                            100%
                          </div>
                          <div style={{ fontSize: 13, color: '#9ca3af' }}>
                            Hands-on training
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default Learn
